import { render, staticRenderFns } from "./salesperson-vue.vue?vue&type=template&id=edfa61fa&scoped=true&"
import script from "./salesperson-vue.vue?vue&type=script&lang=js&"
export * from "./salesperson-vue.vue?vue&type=script&lang=js&"
import style0 from "./salesperson-vue.vue?vue&type=style&index=0&id=edfa61fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfa61fa",
  null
  
)

export default component.exports